/* eslint-disable prettier/prettier */
/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
/* THIS IS AN AUTOGENERATED FILE, DO NOT EDIT DIRECTLY */
import * as components0 from '@commercetools-docs/gatsby-theme-api-docs/shortcodes';
import * as components1 from '@commercetools-docs/gatsby-theme-constants/shortcodes';
import * as components2 from '@commercetools-docs/gatsby-theme-code-examples/shortcodes';

export default {
  ...components0,
  ...components1,
  ...components2,
};
